import { DataGrid, GridColumns } from '@material-ui/data-grid';
import React from 'react';
import { useAdministradora } from '~/pages/CadastroDeAdministradora/hooks/useAdministradora';
import { ContainerTable, ButtonRow } from './styles';
import { FaTrash } from 'react-icons/fa';
import { GoPencil } from 'react-icons/go';
import { insertOrUpdate } from '~/utils/masterDetail';
import { rowsProps } from '../../../types';
import { formatCurrencyAsText } from '~/utils/functions';
import { bandeirasDefault } from '~/pages/CadastroDeAdministradora/DefaultData';
import Tippy from '@tippyjs/react';

export const TableBandeiras: React.FC = () => {
  const {
    rows,
    masterDetail,
    setMasterDetail,
    setRows,
    formBandeiras: { reset },
    setBandeiraId,
    loadingTable,
    setIsEditing,
  } = useAdministradora();
  const columns: GridColumns = [
    {
      field: 'cod_cc',
      headerName: 'Banco',
      sortable: false,
      headerAlign: 'left',
      hide: true,
      disableColumnMenu: true,
    },
    {
      field: 'cod_loja',
      headerName: 'Loja',
      sortable: false,
      headerAlign: 'left',
      hide: false,
      disableColumnMenu: true,
      width: 100,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return <span>{row.cod_loja.value}</span>;
      },
    },
    {
      field: 'des_bandeira',
      headerName: 'Bandeira',
      sortable: false,
      headerAlign: 'left',
      disableColumnMenu: true,
      width: 450,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <Tippy
            content={row.des_bandeira}
            arrow
            animation="scale"
            placement="bottom"
          >
            <span>{row.des_bandeira}</span>
          </Tippy>
        );
      },
    },
    {
      field: 'per_taxa_credito',
      headerName: '% Créd',
      sortable: false,
      align: 'right',
      headerAlign: 'left',
      disableColumnMenu: true,
      width: 160,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return <span>{formatCurrencyAsText(row.per_taxa_credito)}</span>;
      },
    },
    {
      field: 'num_condicao_credito',
      headerName: 'Cond. Créd.',
      sortable: false,
      headerAlign: 'left',
      align: 'right',
      disableColumnMenu: true,
      width: 160,
    },
    {
      field: 'per_taxa_debito',
      headerName: '% Déb',
      align: 'right',
      sortable: false,
      headerAlign: 'left',
      disableColumnMenu: true,
      width: 160,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return <span>{formatCurrencyAsText(row.per_taxa_debito)}</span>;
      },
    },
    {
      field: 'num_condicao_debito',
      headerName: 'Cond. Déb.',
      headerAlign: 'left',
      sortable: false,
      align: 'right',
      disableColumnMenu: true,
      width: 160,
    },
    {
      field: 'per_taxa_parcelado',
      headerName: '% Parcelado',
      headerAlign: 'left',
      sortable: false,
      align: 'right',
      disableColumnMenu: true,
      width: 160,
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return <span>{formatCurrencyAsText(row.per_taxa_parcelado)}</span>;
      },
    },
    {
      field: 'num_condicao_parcela',
      headerName: 'Cond. Parc',
      headerAlign: 'left',
      sortable: false,
      align: 'right',
      disableColumnMenu: true,
      width: 160,
    },
    {
      field: '',
      headerName: 'Ações',
      headerAlign: 'center',
      sortable: false,
      align: 'center',
      disableColumnMenu: true,
      width: 150,
      headerClassName: 'hideRightSeparator',
      renderCell: (params: { row: any }) => {
        const { row } = params;
        return (
          <>
            <ButtonRow
              title="Editar"
              type="button"
              onClick={() => onEditItem(row)}
              disabled={false}
              isBlocked={false}
            >
              <GoPencil size={20} style={{ color: '#72ab90' }} />
            </ButtonRow>
            <ButtonRow
              title="Remover"
              type="button"
              onClick={() => onRemoveItem(row)}
              disabled={false}
              isBlocked={false}
            >
              <FaTrash size={20} style={{ color: '#e63c3c' }} />
            </ButtonRow>
          </>
        );
      },
    },
  ];

  const handleSetFocus = (inputElement: string) => {
    const input = document.querySelector<HTMLInputElement>(
      `input[name="${inputElement}"]`,
    );
    if (input) {
      setTimeout(() => {
        input.focus();
        input.click();
      }, 50);
    }
  };

  const onEditItem = (item: rowsProps) => {
    setIsEditing(true);
    const labelCodCC =
      !item.descricao && !item.cod_cc.descricao
        ? item.cod_cc.label
        : item.cod_cc.descricao
        ? item.cod_cc.descricao
        : item.descricao;
    reset({
      des_bandeira: item.des_bandeira,
      cod_loja: item.cod_loja,
      cod_cc: {
        value: item.cod_cc.value,
        label: labelCodCC,
      },
      per_taxa_credito: formatCurrencyAsText(item.per_taxa_credito),
      num_condicao_credito: item.num_condicao_credito,
      per_taxa_debito: formatCurrencyAsText(item.per_taxa_debito),
      num_condicao_debito: item.num_condicao_debito,
      per_taxa_parcelado: formatCurrencyAsText(item.per_taxa_parcelado),
      num_condicao_parcela: item.num_condicao_parcela,
    });
    setBandeiraId(item.uuid);
    handleSetFocus('des_bandeira');
  };

  const onRemoveItem = async (row: rowsProps) => {
    const formattedValues = {
      ...row,
      flg_remove: true,
    };

    const updateRow: any = await insertOrUpdate(
      'bandeiras',
      formattedValues,
      masterDetail,
      setMasterDetail,
    );
    setRows(updateRow);
    reset(bandeirasDefault);
  };

  return (
    <ContainerTable>
      <DataGrid
        style={{ minHeight: '380px' }}
        className="table mt-4"
        pageSize={5}
        rows={rows.filter((i) => i.flg_remove === false)}
        columns={columns}
        loading={loadingTable}
        sortModel={[{ field: 'des_bandeira', sort: 'asc' }]}
        getRowId={(row) => row.uuid}
        disableColumnFilter
        disableColumnSelector
        disableColumnMenu
        disableSelectionOnClick
        localeText={{
          noRowsLabel: 'Nenhum registro encontrado....',
          columnMenuLabel: 'Menu',
          columnMenuFilter: 'Filtrar',
          columnMenuHideColumn: 'Esconder',
          columnMenuUnsort: 'Não ordenar',
          columnMenuSortAsc: 'Ordernar ASC',
          columnMenuSortDesc: 'Ordernar DESC',
          columnMenuShowColumns: 'Mostrar columnas',
        }}
      />
    </ContainerTable>
  );
};
